import React from 'react';
import { useViewportHeight } from "../../Main/useViewportHeight";

const ScrollWrapper = ({ children, summary }) => {

    const viewportHeight = useViewportHeight();

    let tableHeight;

    if (summary === 1) {
        tableHeight = viewportHeight - 410;
    } if (summary === 1.5) {
        tableHeight = viewportHeight - 330;
    } else if (summary === 1.8) {
        tableHeight = viewportHeight - 350;
    } else if (summary === 2) {
        tableHeight = viewportHeight - 200;
    }  else {
        tableHeight = viewportHeight - 290;
    }

    return (
        <div className="flex-1"
            style={{ maxHeight: `${tableHeight}px` }} >
            <div className="w-full rounded-md overflow-hidden flex flex-col mt-4 h-full">
                <div className="flex-1 overflow-auto hide-scrollbar">
                    {children}
                </div>
            </div>
        </div>
    );
};


export default ScrollWrapper;